module.exports = __webpack_public_path__ + "static/media/attack.75a66b61.png";